import React, { useContext } from 'react';
import styles from './RecordCompareHeaderCard.module.scss';
import HeaderColumn from './RecordCompareHeaderCardColumn';
import { Column, Row } from '../../Layout/RecordCompareLayout';
import I18n from '../../../../I18n/I18n/I18n';
import RecordCompareStateContext from '../../../RecordCompareStateContext';
export default function HeaderCardRow() {
  var _useContext = useContext(RecordCompareStateContext),
    cardView = _useContext.cardView,
    records = _useContext.records;
  return /*#__PURE__*/React.createElement(Row, null, !cardView && /*#__PURE__*/React.createElement(Column, {
    className: styles.record
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: "@dm/components.record-compare.labels.label-header"
  })), records.map(function (record, index) {
    return /*#__PURE__*/React.createElement(HeaderColumn, {
      key: record.id,
      index: index,
      title: record.title
    });
  }));
}